import React from 'react';
import Select from 'react-select';
import WpIcon from 'Wpds/components/icon/WpIcon';

type Props = {
  selectedButtonIds;
  setSelectedButtonIds;
  buttonOptions;
};

const ButtonSelector = ({ selectedButtonIds, setSelectedButtonIds, buttonOptions }: Props) => {
  const addButton = button => {
    if (!selectedButtonIds.find(existing_button => button.value === existing_button.value)) {
      setSelectedButtonIds([...selectedButtonIds, button.value]);
    }
  };

  const removeButton = buttonId => {
    setSelectedButtonIds(selectedButtonIds.filter(selectedButtonId => selectedButtonId !== buttonId));
  };

  const visibleButtonOptions = buttonOptions.filter(
    buttonOption => !selectedButtonIds.find(selectedButtonId => selectedButtonId === buttonOption.value)
  );
  const selectedButtons = selectedButtonIds.map(selectedButtonId =>
    buttonOptions.find(buttonOption => selectedButtonId === buttonOption.value)
  );

  return (
    <>
      {selectedButtonIds.length === 0 && <p className="text-muted">No buttons added.</p>}
      {selectedButtons.map(({ label, value }) => (
        <div className="mt-1" key={value}>
          <button type="button" className="btn btn-secondary mr-1">
            {label}
          </button>
          <span onClick={() => removeButton(value)} className="remove-filter">
            <WpIcon name="times" />
          </span>
        </div>
      ))}
      <div style={{ width: '340px' }} className="mt-3">
        <Select
          className="property mr-2"
          placeholder="Add Button to include in Alert"
          options={visibleButtonOptions}
          value={null}
          onChange={value => addButton(value)}
        />
      </div>
    </>
  );
};

export default ButtonSelector;
